import React, { FC, useState, useEffect } from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { MktButton, PasswordInput, VerifyCodeInput, UseHeader } from '@cps'
import { toast, useHistoryNew } from '@utils'
import { memberMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
}

const Forget: FC<IProps> = () => {
  const history = useHistoryNew()
  const verifyCodeType = memberMobx.verifyCodeTypes.resetPassword
  const [verifyCodeInfo, setVerifyCodeInfo] = useState<any>({})
  const [passwordInfo, setPasswordInfo] = useState<any>({})
  const posResetInfo: any = Config.posResetInfo ? JSON.parse(decodeURIComponent(Config.posResetInfo)) : {}
  // Component Event
  const handleFinish = () => {
    if (!verifyCodeInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipCode') })
      return
    }
    if (!passwordInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipPassword') })
      return
    } else if (!passwordInfo.valid) {
      toast({ message: i18n.t('mkt.common.tipPassword') })
      return
    }
    const params: any = {
      captcha: verifyCodeInfo.inputValue,
      newPwd: passwordInfo.inputValue
    }
    if (posResetInfo.storeDeviceId) {
      params.deviceInfo = { deviceId: posResetInfo.storeDeviceId }
    }
    if (posResetInfo.mobile) {
      params.mobile = posResetInfo.mobile
      params.countryCode = posResetInfo.countryCode
    } else if (posResetInfo.email) {
      params.email = posResetInfo.email
    }
    memberMobx.resetPassword(params, true).then((res: any) => {
      if (res) {
        toast({ message: i18n.t('mkt.member.resetSucc') })
        onBack()
      }
    })
  }
  const onBack = () => {
    mktController.goBack(history)
  }
  useEffect(() => {
    setVerifyCodeInfo({})
    setPasswordInfo({})
  }, [])
  return (
    <IonPage className='forget-scan-page'>
      <UseHeader title={i18n.t('mkt.member.setPassword')} onBack={onBack}></UseHeader>
      <IonContent className='page-content'>
        {
          posResetInfo.mobile || posResetInfo.email
            ? (
              <div className='panel'>
                <div className='des'>
                  <span>{i18n.t('mkt.member.isSendCode', { name: posResetInfo.email ? posResetInfo.email : `+${posResetInfo.countryCode} ${posResetInfo.mobile}` })}，{i18n.t('mkt.member.passwordDes')}</span>
                </div>
                <div className='body'>
                  <VerifyCodeInput
                    autoSend
                    codeType={verifyCodeType} account={posResetInfo.mobile || posResetInfo.email}
                    accountType={posResetInfo.mobile ? 'mobile' : 'email'}
                    countryCode={posResetInfo.countryCode || 0}
                    onChange={(val: any) => setVerifyCodeInfo(val)}
                  />
                  <div className='input-item'>
                    <PasswordInput onChange={(val: any) => setPasswordInfo(val)} />
                  </div>
                </div>
                <div className='footer'>
                  <MktButton text={i18n.t('mkt.common.finish')} onClick={handleFinish} />
                </div>
              </div>
            )
            : <div className='unbind-tip'>{i18n.t('mkt.member.posResetTip')}</div>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(Forget)
